var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 3.75C19.9141 3.75003 20.2499 4.08581 20.2499 4.5V15.75C20.2499 16.1642 19.9141 16.5 19.4999 16.5C19.0857 16.5 18.7499 16.1642 18.7499 15.75V6.31055L5.03022 20.0303C4.73733 20.3232 4.26257 20.3231 3.96967 20.0303C3.67678 19.7374 3.67678 19.2626 3.96967 18.9697L17.6894 5.25H8.24994C7.83573 5.25 7.49994 4.91421 7.49994 4.5C7.49994 4.08579 7.83573 3.75 8.24994 3.75H19.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.709c856baed423351f28a6a5a8c01a36.svg";
export { ForwardRef as ReactComponent };